<template>
	<div v-if="token" class="has-max-width">
		<div class="level is-marginless mb-3">
			<div class="level-left">
				<token-name :token="token"></token-name>
			</div>
			<div class="level-right">
				<p>Created {{ created_date }}</p>
			</div>
		</div>
		<div class="token-panel">
			<div class="columns is-variable is-1">
				<div class="column">
					<div class="token-holder" :class="{ copied: copied }">
						<span class="token">{{ key }}</span>
					</div>
				</div>
				<div class="column is-narrow">
					<div class="buttons">
						<button
							class="button is-light"
							@click.prevent="copyToClipboard"
						>
							<span class="icon is-small">
								<dc-icon
									icon="copy"
									library="far"
									no-margin
								></dc-icon>
							</span>
							<strong>Copy to clipboard</strong>
						</button>
						<app-delete-button @click="revoke(token)">
							<strong class="has-text-danger"
								>Delete API key</strong
							>
						</app-delete-button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { date_long } from "@lab/utils/format";
import { mapActions } from "vuex";

export default {
	name: "TokenDisplay",
	props: {
		token: {
			type: Object,
			default: () => null
		}
	},
	data() {
		return {
			copied: false
		};
	},
	computed: {
		key() {
			return this.token.token;
		},
		created_date() {
			return date_long(new Date(this.token.created));
		},
		name() {
			return this.token.firstname;
		}
	},
	methods: {
		...mapActions({
			revoke: "userTokensModule/revoke"
		}),
		copyToClipboard: function () {
			this.$copyText(this.key).then(() => {
				this.copied = true;
				setTimeout(() => {
					this.copied = false;
				}, 1000);
			});
		},
		updateName(name) {
			console.log(name);
		}
	}
};
</script>

<style lang="scss">
.token-panel {
	margin-bottom: 2.5rem;
	padding: 0.75rem;
	background-color: $white-ter;
}

.token-holder {
	height: 2.5em;
	position: relative;

	.token {
		display: block;
		position: relative;

		&::after {
			content: "Copied to clipboard";
			text-align: center;
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			background-color: $white-ter;
			opacity: 0;
		}
	}

	&.copied .token::after {
		opacity: 1;
	}
}
</style>
